/* eslint-disable react-hooks/exhaustive-deps */
import { ArtButton, DAOButton } from "components/button";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducer/store";
import {
  bulkSetUserInfo,
  clearUserInfo,
  setUserInfo,
} from "reducer/user.slice";
import { clearAuthInfos } from "reducer/wallet.slice";
import { Card } from "semantic-ui-react";
import { api, ui, utils } from "services";
import { Chain, CustomerInterface, LoginType } from "interfaces";
import Stake from "./stake";
import Unstake from "./unstake";
import Config from "config";
import { useInterval } from "services/useInterval";
import walletConnect from "services/wallet-connect";
import StakeFT from "./stakeFT";
import UnstakeFT from "./unstakeFT";
import StakePeriod from "./stake-period";
import { CardComponent } from "./card-component";
import { TransactionTable } from "./transaction-table";
import { SharedRevenueCard } from "./doughnut";
import { StakeTable } from "./stake-table";
import { ChartLine } from "./chart-line";

export default function Home() {
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.user);
  const loginType = useSelector((state: RootState) => state.logintype);
  const [openStake, setOpenStake] = useState(false);
  const [openUnstake, setOpenUnstake] = useState(false);
  const [unit, setUnit] = useState("");

  const [openFTStake, setFTOpenStake] = useState(false);
  const [openFTUnstake, setFTOpenUnstake] = useState(false);
  const [ftUnit, setFTUnit] = useState("");

  const [stakeConfig, setStakeConfig] = useState<any>({});
  const [myReward, setMyReward] = useState<any>({});
  const [loadingRestake, setLoadingRestake] = useState<boolean>(false);
  const [loadingWithdraw, setLoadingWithdraw] = useState<boolean>(false);
  const [trigger, setTrigger] = useState<boolean>(false);
  const [usdtGuaranteeRequired, setRequired] = useState(0);

  const dispatch = useDispatch();
  const [recentTransaction, setRecentTransaction] = useState(null);
  const [revenueIncentives, setRevenueIncentives] = useState([
    {
      title: "In-game",
      color: "#52ACFF",
      rate: 0,
      pool: 0,
    },
    {
      title: "6 months",
      color: "#FBE947",
      rate: 0,
      pool: 0,
    },
    {
      title: "9 months",
      color: "#EF7BE3",
      rate: 0,
      pool: 0,
    },
    {
      title: "12 months",
      color: "#76FFFF",
      rate: 0,
      pool: 0,
    },
  ]);

  const [openStakePeriod, setOpenStakePeriod] = useState(false);
  const [withdrawAmount, setWithdraw] = useState(0);

  const checkIAPLock = async () => {
    let usdt = user?.[CustomerInterface.usdt_guaranteed] ?? 0;
    let rs = await api.post("/dao/get-usdt-guarantee", {});
    let dif = Number(usdt) - Number(rs);
    if (dif < 0) {
      return Math.abs(dif);
    }
    return 0;
  };

  async function loadUserInfo() {
    let rs = await api.post("/dao/get-customer-info", {});
    dispatch(bulkSetUserInfo(rs));
  }

  async function loadUsdt() {
    let rs = await api.post("/dao/get-usdt-guarantee", {});
    setRequired(rs);
  }

  async function loadConfig() {
    let rs = await api.post("/config/get-stake-information-public", {});

    if (rs) {
      let mstrIngameRate = rs.MstrSharedRevenueInGameRate;
      let mstrTimeRate = rs.MstrSharedRevenueTimeRate;

      let mstrIngamePool = rs.mstrInGamePool;
      let mstrTimePool = rs.mstrTimePool;

      let data = revenueIncentives.map((i, index) => {
        return {
          ...i,
          rate: [mstrIngameRate, ...mstrTimeRate][index],
          pool: [mstrIngamePool, ...mstrTimePool][index],
        };
      });

      setStakeConfig(rs);
      setRevenueIncentives(data);
    }
  }

  async function loadMyReward() {
    if (!sessionStorage.getItem("token")) {
      sessionStorage.clear();
      localStorage.clear();
      dispatch(clearUserInfo());
      dispatch(clearAuthInfos());
      return;
    }
    let rs = await api.post("/dao/get-stake-information", {});
    setMyReward(rs);
  }

  useEffect(() => {
    if (openUnstake) {
      loadUserInfo();
    }
  }, [openUnstake, trigger]);
  async function loadAllBalance(){
    api.getMAGBalance().then((bal) => {
      dispatch(setUserInfo({ mag_wallet: bal }));
    });
    api.getMSTRBalance().then((bal) => {
      dispatch(setUserInfo({ mstr_wallet: bal }));
    });
  }
  useEffect(() => {
    if (!openStake) return;
    if (unit === "MAG") {
      api.getMAGBalance().then((bal) => {
        dispatch(setUserInfo({ mag_wallet: bal }));
      });
    } else if (unit === "MSTR") {
      api.getMSTRBalance().then((bal) => {
        dispatch(setUserInfo({ mstr_wallet: bal }));
      });
    } else if (unit === "USDT") {
      api.getUSDTBalance().then((bal) => {
        dispatch(setUserInfo({ usdt_wallet: bal }));
      });
    }
  }, [openStake]);
  useEffect(() => {
    let interval = setInterval(() => {
      loadAllBalance();
    }, 5000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    loadConfig();
    if (user?.[CustomerInterface.id] && sessionStorage.getItem("token")) {
      loadUsdt();
    }
    if (!user?.[CustomerInterface.id]) {
      setMyReward({});
      return;
    }
    loadMyReward();
  }, [trigger, user?.[CustomerInterface.id]]);

  useInterval(() => {
    setTrigger(!trigger);
  }, 1000 * 60 * 5);

  useEffect(() => {
    const loadAllConfig = async () => {
      await loadConfig();
      await loadMyReward();
    };
    window.addEventListener("focus", loadAllConfig);
    return () => {
      window.removeEventListener("focus", loadAllConfig);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.[CustomerInterface.id]]);

  return (
    <div
      className="w-full bg-[#100f11] max-w-screen px-6 lg:px-0"
      id="resize-content"
      style={{
        zoom: 0.9,
      }}
    >
      {/* <Stake
        unit={unit}
        open={openStake}
        stakeConfig={stakeConfig}
        onClose={() => {
          setOpenStake(false);
        }}
        onSuccess={() => setTrigger(!trigger)}
      /> */}
      <Unstake
        unit={unit}
        open={openUnstake}
        onClose={() => {
          setOpenUnstake(false);
        }}
        setRecentTransaction={setRecentTransaction}
        onSuccess={() => setTrigger(!trigger)}
        stakeConfig={stakeConfig}
        trigger={trigger}
        setTrigger={setTrigger}
        usdtGuaranteeRequired={usdtGuaranteeRequired}
      />
      {/* <StakeFT
        unit={ftUnit}
        open={openFTStake}
        stakeConfig={stakeConfig}
        onClose={() => {
          setFTOpenStake(false);
        }}
        onSuccess={() => setTrigger(!trigger)}
      /> */}
      <UnstakeFT
        unit={ftUnit}
        stakeConfig={stakeConfig}
        open={openFTUnstake}
        onClose={() => {
          setFTOpenUnstake(false);
        }}
        onSuccess={() => setTrigger(!trigger)}
      />
      {/* <StakePeriod
        stakeConfig={stakeConfig}
        open={openStakePeriod}
        onClose={() => setOpenStakePeriod(false)}
        estimateShare={
          (user?.[CustomerInterface.mstr] ?? 0) /
          (stakeConfig?.totalMagStakeInGame ?? 1)
        }
        trigger={trigger}
        setTrigger={setTrigger}
        withdrawAmount={withdrawAmount}
        setWithdraw={setWithdraw}
      /> */}

      <div className="xl:grid xl:grid-cols-5 w-full max-w-screen relative min-h-screen">
        <div className="col-span-1 xl:col-span-4 px-10 md:px-20 w-full relative">
          <div className="w-full px-8 relative block xl:hidden">
            <SharedRevenueCard revenueIncentives={revenueIncentives} />
          </div>

          <div className="mt-7 w-full relative max-w-[1290px] mx-auto">
            <Card
              fluid
              style={{ background: "transparent", boxShadow: "none" }}
              description={
                <div className="flex flex-col gap-x-1 gap-y-3 w-full">
                  <div className="gap-y-2 gap-x-4 mt-10">
                    <div className="w-full text-white text-lg md:text-2xl relative">
                      <div className="absolute bottom-1 font-bold font-cookie">
                        Stake
                      </div>
                    </div>
                    <div className="w-full xl:grid grid-cols-1 xl:grid-cols-2 mt-4 gap-x-3 gap-y-6">
                      <CardComponent
                        title="In-game MSTR Deposit"
                        titleIcon="/assets/images/items/mstr-icon.svg"
                        sharedRevenue={utils.convertToInternationalCurrencySystem(
                          Number(stakeConfig?.mstrInGamePool ?? 0)
                        )}
                        apr={
                          utils.displayFloat(
                            Number(stakeConfig?.mstrRate) * 100,
                            2,
                            false
                          ) + " %"
                        }
                        borderColor="#D68710"
                        contentColor="#16151B"
                        balance={utils.convertToInternationalCurrencySystem(
                          user?.[CustomerInterface.mstr] ?? 0
                        )}
                        totalBalance={utils.convertToInternationalCurrencySystem(
                          stakeConfig?.totalMstrStakeInGame
                        )}
                        unstakeFn={() => {
                          if (
                            !user?.[CustomerInterface.id] ||
                            !sessionStorage.getItem("token")
                          ) {
                            return;
                          }
                          if (Config.ChainAuth.includes(loginType)) {
                            setUnit("MSTR");
                            setOpenUnstake(true);
                          } else {
                            ui.alertFailed(
                              "Unstake MSTR failed !",
                              "You must connect wallet to use this feature !"
                            );
                          }
                        }}
                        stakeFn={() => {
                          if (
                            !user?.[CustomerInterface.id] ||
                            !sessionStorage.getItem("token")
                          ) {
                            return;
                          }
                          if (Config.ChainAuth.includes(loginType)) {
                            setUnit("MSTR");
                            setOpenStake(true);
                          } else {
                            ui.alertFailed(
                              "Stake MSTR failed !",
                              "You must connect wallet to use this feature !"
                            );
                          }
                        }}
                        claimFn={async () => {
                          try {
                            setLoadingWithdraw(true);
                            await api.claimMstrStake(true, loginType);
                            setTrigger(!trigger);
                            setLoadingWithdraw(false);
                            ui.alertSuccess(
                              "Transaction is on processing!",
                              <>
                                You will receive your reward when transaction
                                succeed.
                              </>
                            );
                          } catch (err: any) {
                            setTrigger(!trigger);
                            ui.alertFailed(
                              "Withdraw reward failed !",
                              t(err?.message ?? err)
                            );
                            setLoadingWithdraw(false);
                          }
                        }}
                        restakeFn={async () => {
                          try {
                            setLoadingRestake(true);
                            const { customerInfo } = await api.restakeMstrStake(
                              true
                            );
                            setTrigger(!trigger);
                            setLoadingRestake(false);
                            dispatch(bulkSetUserInfo(customerInfo));
                            ui.alertSuccess("Restake successful !", "");
                          } catch (err: any) {
                            ui.alertFailed(
                              "Restake failed !",
                              t(err?.message ?? err)
                            );
                            setLoadingRestake(false);
                          }
                        }}
                        rewardValue={myReward?.mstrStakeRevenueInGame}
                        totalReward={
                          <div className="font-medium text-lg md:text-2xl">
                            {myReward
                              ? utils.convertToInternationalCurrencySystem(
                                  myReward?.mstrStakeRevenueInGame ?? 0,
                                  8
                                )
                              : "--"}{" "}
                            MSTR
                          </div>
                        }
                      />

                      <CardComponent
                        title="In-game MAG Deposit"
                        titleIcon="/assets/images/items/mag-icon-large.webp"
                        sharedRevenue={utils.convertToInternationalCurrencySystem(
                          Number(stakeConfig?.magInGamePool ?? 0)
                        )}
                        apr={
                          utils.displayFloat(
                            Number(stakeConfig?.magRate) * 100,
                            2,
                            false
                          ) + " %"
                        }
                        borderColor="#25B08F"
                        contentColor="#16151B"
                        balance={utils.convertToInternationalCurrencySystem(
                          user?.[CustomerInterface.staked_mag] ?? 0
                        )}
                        totalBalance={utils.convertToInternationalCurrencySystem(
                          stakeConfig?.totalMagStakeInGame
                        )}
                        unstakeFn={() => {
                          if (
                            !user?.[CustomerInterface.id] ||
                            !sessionStorage.getItem("token")
                          ) {
                            return;
                          }
                          if (Config.ChainAuth.includes(loginType)) {
                            setUnit("MAG");
                            setOpenUnstake(true);
                          } else {
                            ui.alertFailed(
                              "Unstake MAG failed !",
                              "You must connect wallet to use this feature !"
                            );
                          }
                        }}
                        stakeFn={() => {
                          if (
                            !user?.[CustomerInterface.id] ||
                            !sessionStorage.getItem("token")
                          ) {
                            return;
                          }
                          if (Config.ChainAuth.includes(loginType)) {
                            setUnit("mag");
                            setOpenStake(true);
                          } else {
                            ui.alertFailed(
                              "Stake MAG failed !",
                              "You must connect wallet to use this feature !"
                            );
                          }
                        }}
                        claimFn={async () => {
                          try {
                            setLoadingWithdraw(true);
                            await api.claimMagStake(loginType);
                            setTrigger(!trigger);
                            setLoadingWithdraw(false);
                            ui.alertSuccess(
                              "Transaction is on processing!",
                              <>
                                You will receive your reward when transaction
                                succeed.
                              </>
                            );
                          } catch (err: any) {
                            setTrigger(!trigger);
                            ui.alertFailed(
                              "Withdraw reward failed !",
                              t(err?.message ?? err)
                            );
                            setLoadingWithdraw(false);
                          }
                        }}
                        restakeFn={async () => {
                          try {
                            setLoadingRestake(true);
                            const { customerInfo } =
                              await api.restakeMagStake();
                            setTrigger(!trigger);
                            setLoadingRestake(false);
                            dispatch(bulkSetUserInfo(customerInfo));
                            ui.alertSuccess("Restake successful !", "");
                          } catch (err: any) {
                            ui.alertFailed(
                              "Restake failed !",
                              t(err?.message ?? err)
                            );
                            setLoadingRestake(false);
                          }
                        }}
                        rewardValue={myReward?.magStakeRevenueInGame}
                        totalReward={
                          <div className="font-medium text-lg md:text-2xl">
                            {myReward
                              ? utils.convertToInternationalCurrencySystem(
                                  myReward?.magStakeRevenueInGame ?? 0,
                                  8
                                )
                              : "--"}{" "}
                            MAG
                          </div>
                        }
                      />

                      <div className="col-span-1 col-span-2">
                        <CardComponent
                          title="USDT Guaranteed"
                          titleIcon="/assets/images/button/usdt-icon.webp"
                          sharedRevenue={utils.convertToInternationalCurrencySystem(
                            Number(stakeConfig?.magInGamePool ?? 0)
                          )}
                          apr={
                            utils.displayFloat(
                              Number(stakeConfig?.magRate) * 100,
                              2,
                              false
                            ) + " %"
                          }
                          borderColor="#2d2f30"
                          contentColor="#16151B"
                          balance={utils.convertToInternationalCurrencySystem(
                            user?.[CustomerInterface.usdt_guaranteed] ?? 0
                          )}
                          totalBalance={utils.convertToInternationalCurrencySystem(
                            usdtGuaranteeRequired
                          )}
                          isUsdt={true}
                          unstakeFn={() => {
                            if (
                              !user?.[CustomerInterface.id] ||
                              !sessionStorage.getItem("token")
                            ) {
                              return;
                            }
                            if (Config.ChainAuth.includes(loginType)) {
                              setUnit("USDT");
                              setOpenUnstake(true);
                            } else {
                              ui.alertFailed(
                                "Unstake USDT failed !",
                                "You must connect wallet to use this feature !"
                              );
                            }
                          }}
                          stakeFn={() => {
                            if (
                              !user?.[CustomerInterface.id] ||
                              !sessionStorage.getItem("token")
                            ) {
                              return;
                            }
                            if (Config.ChainAuth.includes(loginType)) {
                              setUnit("USDT");
                              setOpenStake(true);
                            } else {
                              ui.alertFailed(
                                "Stake USDT failed !",
                                "You must connect wallet to use this feature !"
                              );
                            }
                          }}
                        />
                      </div>

                      <div className="w-full col-span-2 mt-4 xl:mt-0">
                        <img
                          className=" object-cover w-full h-full"
                          src="/assets/images/stake-banner.png"
                        />
                      </div>

                      <div className="col-span-2 xl:col-span-2 rounded-xl font-cookie w-full mt-4 xl:mt-0">
                        <StakeTable
                          trigger={trigger}
                          setTrigger={setTrigger}
                          myReward={myReward}
                          setOpenStakePeriod={setOpenStakePeriod}
                          stakeConfig={stakeConfig}
                          setRecentTransaction={setRecentTransaction}
                          setWithdraw={setWithdraw}
                        />
                      </div>

                      <div className="col-span-2 xl:col-span-2">
                        <ChartLine />
                      </div>

                      <div className="text-white px-5 pt-5 pb-3 bg-[#1F1D24] rounded-xl relative mt-2">
                        <div className="flex gap-2 py-2 pb-8">
                          <img
                            src={"/assets/images/items/elixir-icon.webp"}
                            alt="mstr"
                            className="inline-block mr-2 h-10 w-auto"
                          />
                          <div className="text-white self-center font-bold text-lg">
                            Elixir Manage Tool
                          </div>
                        </div>
                        <div className="text-[#A5A5A5]">
                          <div className="flex gap-4 justify-between w-full">
                            <div>In game amount</div>
                            <div className="text-white">
                              {utils.convertToInternationalCurrencySystem(
                                user?.[CustomerInterface.elixir],
                                8
                              ) || "--"}{" "}
                            </div>
                          </div>
                          <div className="flex gap-4 justify-between w-full">
                            <div>Wallet amount</div>
                            <div className="text-white">
                              {utils.convertToInternationalCurrencySystem(
                                user?.elixir_wallet,
                                8
                              ) || "--"}{" "}
                            </div>
                          </div>
                        </div>
                        <div className="flex gap-4 justify-end mt-2 pt-2">
                          <div className="w-[120px]">
                            <DAOButton
                              disabled={
                                !user?.[CustomerInterface.id] ||
                                !sessionStorage.getItem("token")
                              }
                              icon="unstake-icon.png"
                              theme="light"
                              color="white"
                              onClick={async () => {
                                if (
                                  !user?.[CustomerInterface.id] ||
                                  !sessionStorage.getItem("token")
                                ) {
                                  return;
                                }
                                let isIAPLock = await checkIAPLock();
                                if (isIAPLock) {
                                  ui.openIAPNoti(isIAPLock);
                                } else {
                                  try {
                                    walletConnect.preventWalletConnect();
                                  } catch (err) {
                                    return;
                                  }
                                  if (Config.ChainAuth.includes(loginType)) {
                                    setFTUnit("ELIXIR");
                                    setFTOpenUnstake(true);
                                  } else {
                                    ui.alertFailed(
                                      "Unstake ELIXIR failed !",
                                      "You must connect wallet to use this feature !"
                                    );
                                  }
                                }
                              }}
                            >
                              Unstake
                            </DAOButton>
                          </div>
                          {/* <div className="w-[120px]">
                            <DAOButton
                              disabled={
                                !user?.[CustomerInterface.id] ||
                                !sessionStorage.getItem("token")
                              }
                              icon="add-icon.png"
                              theme="light"
                              color="yellow"
                              onClick={() => {
                                if (
                                  !user?.[CustomerInterface.id] ||
                                  !sessionStorage.getItem("token")
                                ) {
                                  return;
                                }
                                try {
                                  walletConnect.preventWalletConnect();
                                } catch (err) {
                                  return;
                                }
                                if (Config.ChainAuth.includes(loginType)) {
                                  setFTUnit("ELIXIR");
                                  setFTOpenStake(true);
                                } else {
                                  ui.alertFailed(
                                    "Stake ELIXIR failed !",
                                    "You must connect wallet to use this feature !"
                                  );
                                }
                              }}
                            >
                              Add more
                            </DAOButton>
                          </div> */}
                        </div>
                      </div>
                      <div className="text-white px-5 pt-5 pb-3 bg-[#1F1D24] rounded-xl relative mt-2">
                        <div className="flex gap-2 py-2 pb-8">
                          <img
                            src={"/assets/images/items/mutategen-icon.webp"}
                            alt="mutated"
                            className="inline-block mr-2 h-10 w-auto"
                          />
                          <div className="text-white self-center font-bold text-lg">
                            Mutated Gen Manage Tool
                          </div>
                        </div>
                        <div className="text-[#A5A5A5]">
                          <div className="flex gap-4 justify-between w-full">
                            <div>In game amount</div>
                            <div className="text-white">
                              {utils.convertToInternationalCurrencySystem(
                                user?.[CustomerInterface.mutated_gen],
                                8
                              ) || "--"}{" "}
                            </div>
                          </div>
                          <div className="flex gap-4 justify-between w-full">
                            <div>Wallet amount</div>
                            <div className="text-white">
                              {utils.convertToInternationalCurrencySystem(
                                user?.mutategen_wallet,
                                8
                              ) || "--"}{" "}
                            </div>
                          </div>
                        </div>
                        <div className="flex gap-4 justify-end mt-2 pt-2">
                          <div className="w-[120px]">
                            <DAOButton
                              disabled={
                                !user?.[CustomerInterface.id] ||
                                !sessionStorage.getItem("token")
                              }
                              icon="unstake-icon.png"
                              theme="light"
                              color="white"
                              onClick={async () => {
                                if (
                                  !user?.[CustomerInterface.id] ||
                                  !sessionStorage.getItem("token")
                                ) {
                                  return;
                                }
                                let isIAPLock = await checkIAPLock();
                                if (isIAPLock) {
                                  ui.openIAPNoti(isIAPLock);
                                } else {
                                  try {
                                    walletConnect.preventWalletConnect();
                                  } catch (err) {
                                    return;
                                  }
                                  if (Config.ChainAuth.includes(loginType)) {
                                    setFTUnit("MUTATEGEN");
                                    setFTOpenUnstake(true);
                                  } else {
                                    ui.alertFailed(
                                      "Unstake Mutated Gen failed !",
                                      "You must connect wallet to use this feature !"
                                    );
                                  }
                                }
                              }}
                            >
                              Unstake
                            </DAOButton>
                          </div>
                          {/* <div className="w-[120px]">
                            <DAOButton
                              disabled={
                                !user?.[CustomerInterface.id] ||
                                !sessionStorage.getItem("token")
                              }
                              icon="add-icon.png"
                              theme="light"
                              color="yellow"
                              onClick={() => {
                                if (
                                  !user?.[CustomerInterface.id] ||
                                  !sessionStorage.getItem("token")
                                ) {
                                  return;
                                }
                                try {
                                  walletConnect.preventWalletConnect();
                                } catch (err) {
                                  return;
                                }
                                if (Config.ChainAuth.includes(loginType)) {
                                  setFTUnit("MUTATEGEN");
                                  setFTOpenStake(true);
                                } else {
                                  ui.alertFailed(
                                    "Stake Mutated Gen failed !",
                                    "You must connect wallet to use this feature !"
                                  );
                                }
                              }}
                            >
                              Add more
                            </DAOButton>
                          </div> */}
                        </div>
                      </div>
                    </div>

                    <TransactionTable
                      trigger={trigger}
                      setTrigger={setTrigger}
                      recentTransaction={recentTransaction}
                    />
                  </div>
                </div>
              }
            />
          </div>
        </div>

        <div className="hidden xl:block col-span-1 h-full">
          <div className="bg-black fixed w-full h-full px-5 relative">
            <SharedRevenueCard revenueIncentives={revenueIncentives} />
          </div>
        </div>
      </div>
    </div>
  );
}
